import { iChromiaState } from "../../interfaces/chrInterfaces";
import { createStoreRecord } from "../../utils/Chromia/utils";
import { eChromiaActionTypes, tChromiaAction } from "./chromiaTypes";


const initialState: iChromiaState = {
	session: null,
	chrClientAddr: null,
	gtxClient: null,
	isChrRegistered: true,
	items: createStoreRecord(null),

	activeDeposit: createStoreRecord(null),
	pendingDeposit: createStoreRecord(null),
	withdrawRequest: createStoreRecord(null),
	withdrawAvailable: createStoreRecord(null),

	allInfo: createStoreRecord(null),

	tokenBalances: [],
	chrNodeUrl: null,
}

export const chromiaReducer = (state = initialState, action: tChromiaAction): iChromiaState => {
	switch(action.type){

		case eChromiaActionTypes.CLEAR_STATE:
			return initialState
		;

		case eChromiaActionTypes.SET_SESSION:
			return {...state, session: action.payload}
		;

		case eChromiaActionTypes.SET_CHR_CLIENT_ADDR:
			return {...state, chrClientAddr: action.payload}
		;

		case eChromiaActionTypes.SET_GTX_CLIENT:
			return {...state, gtxClient: action.payload}
		;

		/* case eChromiaActionTypes.SET_DEPOSITS:
			return {
				...state,
				deposits: Object.assign(
					{},
					state.deposits,
					{[action.payload.percent]: action.payload.deposits}
				)
			}
		; */
		
		case eChromiaActionTypes.SET_IS_CHR_REGISTERED:
			return {...state, isChrRegistered: action.payload}
		;

		/* case eChromiaActionTypes.SET_ITEM:
			return {
				...state,
				items: Object.assign(
					{},
					state.items,
					{[action.payload.percent]: action.payload.item}
				)
			}
		; */
		case eChromiaActionTypes.SET_ITEMS:
			return {...state, items: action.payload}
		;

		/* case eChromiaActionTypes.SET_END_TIME:
			return {
				...state,
				endTimes: Object.assign(
					{},
					state.endTimes,
					{[action.payload.percent]: action.payload.endTime}
				)
			}
		; */


		case eChromiaActionTypes.SET_ACTIVE_DEPOSIT:
			/* return {
				...state,
				activeDeposit: Object.assign(
					{},
					state.activeDeposit,
					{[action.payload.percent]: action.payload.deposit}
				)
			} */
			const activeDepositsClone = structuredClone(state.activeDeposit);
			activeDepositsClone[action.payload.fToken][action.payload.uToken][action.payload.percent] = action.payload.deposit;
			return {...state, activeDeposit: activeDepositsClone}
		;

		case eChromiaActionTypes.SET_PENDING_DEPOSIT:
			/* return {
				...state,
				pendingDeposit: Object.assign(
					{},
					state.pendingDeposit,
					{[action.payload.percent]: action.payload.deposit}
				)
			} */
			const pendingDepositsClone = structuredClone(state.pendingDeposit);
			pendingDepositsClone[action.payload.fToken][action.payload.uToken][action.payload.percent] = action.payload.deposit;
			return {...state, pendingDeposit: pendingDepositsClone}
		;

		case eChromiaActionTypes.SET_WITHDRAW_REQUEST:
			/* return {
				...state,
				withdrawRequest: Object.assign(
					{},
					state.withdrawRequest,
					{[action.payload.percent]: action.payload.request}
				)
			} */
			const withdrawRequestsClone = structuredClone(state.withdrawRequest);
			withdrawRequestsClone[action.payload.fToken][action.payload.uToken][action.payload.percent] = action.payload.request;
			return {...state, withdrawRequest: withdrawRequestsClone}
		;

		case eChromiaActionTypes.SET_WITHDRAW_AVAILABLE:
			/* return {
				...state,
				withdrawAvailable: Object.assign(
					{},
					state.withdrawAvailable,
					{[action.payload.percent]: action.payload.amounts}
				)
			} */
			const availableWithdrawsClone = structuredClone(state.withdrawAvailable);
			availableWithdrawsClone[action.payload.fToken][action.payload.uToken][action.payload.percent] = action.payload.amounts;
			return {...state, withdrawAvailable: availableWithdrawsClone}
		;

		case eChromiaActionTypes.SET_ACTIVE_DEPOSITS:
			return {...state, activeDeposit: action.payload}
		;

		case eChromiaActionTypes.SET_PENDING_DEPOSITS:
			return {...state, pendingDeposit: action.payload}
		;

		case eChromiaActionTypes.SET_AVAILABLE_WITHDRAWS:
			return {...state, withdrawAvailable: action.payload}
		;

		case eChromiaActionTypes.SET_WITHDRAW_REQUESTS:
			return {...state, withdrawRequest: action.payload}
		;

		case eChromiaActionTypes.SET_ALL_INFO:
			return {...state, allInfo: action.payload}
		;


		case eChromiaActionTypes.SET_TOKEN_BALANCES:
			return {...state, tokenBalances: action.payload}
		;

		case eChromiaActionTypes.SET_CHR_NODE_URL:
			return {...state, chrNodeUrl: action.payload}
		;

		default: return state;
	}
}